/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Economics15Inputs */

const en__field__enum_studyprograms_study_economics15 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Economics15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economics`)
};

const de__field__enum_studyprograms_study_economics15 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Economics15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirtschaftswissenschaften`)
};

/**
* | output |
* | --- |
* | "Economics" |
*
* @param {_Field__Enum_Studyprograms_Study_Economics15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_economics15 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Economics15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Economics15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_economics15(inputs)
	return de__field__enum_studyprograms_study_economics15(inputs)
});
export { _field__enum_studyprograms_study_economics15 as "_field__enum_studyPrograms_STUDY_ECONOMICS" }